import { useQuery } from "@tanstack/react-query";
import {
  fetchMetaAdsAdAccountCampaigns,
  getMetaAdsApiBaseUrl,
  isMetaAdsApiConfigured,
} from "./useMetaAdsApi";

/**
 * Live ad-account campaigns from the Meta Graph API (and insights), not Supabase.
 */
export function useMetaAdsGraphCampaigns(options = {}) {
  const { enabled = true, datePreset = "last_30d" } = options;
  return useQuery({
    queryKey: ["meta-ads-graph-campaigns", "ad-account", datePreset],
    queryFn: () => fetchMetaAdsAdAccountCampaigns(datePreset),
    enabled: Boolean(enabled && isMetaAdsApiConfigured()),
    staleTime: 60_000,
  });
}

export { getMetaAdsApiBaseUrl, isMetaAdsApiConfigured };
